let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aE0xg")).then(() => parcelRequire('jus15'));